import React, { Component } from 'react';
import { BannerCmp } from '../component';
import FooterInfo from './FooterInfo';

class Footer extends React.Component { 
    constructor(props){
        super(props);
    }
    
    render(){
        return (
            <React.Fragment>
            <footer>
                <div className="inner">
                    <FooterInfo />
                </div>
            </footer>
            </React.Fragment>
        )
    }

};

export default Footer;